import React from 'react'

import { Button, Col, Portlet, Row } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as FormGroups from './formGroups'

import * as InventarioService from 'services/inventario.service'

import { DateHandler } from 'utils'
import * as Sections from './sections'

const ConsultasKardex = () => {
  const __zariContext = React.useContext(ZariContext)

  const [fechaDesde, setFechaDesde] = React.useState('')
  const [fechaHasta, setFechaHasta] = React.useState('')
  const [multiAlmacenCheck, setMulitAlmacenCheck] = React.useState(true)
  const [productoSeleccionado, setProductoSeleccionado] = React.useState(null)
  const [clienteSeleccionado, setClienteSeleccionado] = React.useState(null)
  const [sectionData, setSectionData] = React.useState(null)
  const [flagClienteSeleccionado, setFlagClienteSeleccionado] = React.useState(false)

  React.useEffect(() => {
    const fecha = new Date()
    const anio = fecha.getFullYear()
    const primerDiaMes = new Date(anio, 0, 1)
    setFechaDesde(DateHandler.format(primerDiaMes))
    setFechaHasta(DateHandler.format(fecha))
  }, [])

  const clickVerInforme = React.useCallback(() => {
    let idProducto = productoSeleccionado ? productoSeleccionado._id : null
    let idCliente = clienteSeleccionado ? clienteSeleccionado._id : null
    if (!fechaDesde || !fechaHasta) {
      __zariContext.snack('error', 'El campo fecha es requerido')
    } else if (fechaDesde.split('/')[2] !== fechaHasta.split('/')[2]) {
      __zariContext.snack('error', 'Las fechas deben estar en el mismo año.')
    } else {
    __zariContext.loader.open('Consultando informacion con filtros ingresados.')
      InventarioService.obtenerConsultaKardexAsTable({
        fechaDesde,
        fechaHasta,
        multiAlmacenCheck,
        idProducto,
        idCliente
      }).then(({ data }) => {
        if (clienteSeleccionado !== null) {
          setFlagClienteSeleccionado(true)
        } else {
          setFlagClienteSeleccionado(false)
        }

        setSectionData({
          data
        })
      }).finally(() => {
        __zariContext.loader.close()
      })
    }
  }, [fechaDesde, fechaHasta, multiAlmacenCheck, productoSeleccionado, clienteSeleccionado, __zariContext])

  const limpiarTabla = React.useCallback(() => {
    setSectionData(null)
  }, [])

  return (
    <>
      <Row>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='CONSULTAS KARDEX' />
            <Portlet.Body>
              <Row>
                <Col md={12}>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <FormGroups.FechaFormGroup
                        text='Desde'
                        value={fechaDesde}
                        handleChange={e => {
                          setFechaDesde(e.target.value)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                    <Col md={5}>
                      <FormGroups.FechaFormGroup
                        text='Hasta'
                        value={fechaHasta}
                        handleChange={e => {
                          setFechaHasta(e.target.value)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={5}>
                      <FormGroups.CheckBoxFormGroup
                        text='Multi Almacen'
                        value={multiAlmacenCheck}
                        handleChange={() => {
                          setMulitAlmacenCheck(prev => !prev)
                          limpiarTabla()
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={12}>
                      <FormGroups.ProductosFormGroup
                        value={productoSeleccionado}
                        setValue={setProductoSeleccionado}
                        limpiarTabla={limpiarTabla}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                    <Col md={12}>
                      <FormGroups.ClientesFormGroup
                        value={clienteSeleccionado}
                        setValue={setClienteSeleccionado}
                        limpiarTabla={limpiarTabla}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button onClick={clickVerInforme}>Ver Pantalla</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
      {sectionData !== null && !flagClienteSeleccionado && (
        <Row>
          <Sections.TablaKardexProductosSection sectionData={sectionData} />
        </Row>
      )}
      {sectionData !== null && flagClienteSeleccionado && (
        <Row>
          <Sections.TablaKardexClientesSection sectionData={sectionData} />
        </Row>
      )}
    </>
  )
}

export default React.memo(ConsultasKardex)
